import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor } from '@angular/common/http';
import { SecurityService } from './security/security.service';

/*
 * Auth Token Interceptor
 *
 * TECHNOLOGY: HTTP Interceptor
 * Interceptors are a way to inspect/transform HTTP requests sent from the application
 * to the server. They act like middleware in the frontend.
 *
 * PURPOSE:
 * Automatically attaching the 'Authorization' header (JWT token) and 'caid' to 
 * EVERY outgoing HTTP request, so developers don't have to manually add it 
 * in every service call.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthTokenInterceptorService implements HttpInterceptor {

  constructor(private injector: Injector) { }

  /*
   * METHOD: intercept
   * 1. Retrieves the Auth Token from SecurityService.
   * 2. CLONES the original request (requests are immutable in Angular).
   * 3. Adds the Authorization header to the cloned request.
   * 4. Passes the modified request to the next handler.
   */
  intercept(req, next) {
    let authService = this.injector.get(SecurityService);

    // Determine if this is an MWM request
    const isMwmRequest = req.url.includes('/api/mwm-');

    let token;
    if (isMwmRequest) {
      token = authService.getMwmAuthToken();
      // MWM Token needs Bearer prefix if not present (usually stored raw)
      if (token && !token.startsWith('Bearer ')) {
        token = 'Bearer ' + token;
      }
    } else {
      token = authService.getAuthToken();
      if (token && !token.startsWith('Bearer ')) {
        token = 'Bearer ' + token;
      }
    }

    let caid = authService.getCaid();

    let headers: any = {};

    if (token) {
      headers['Authorization'] = token;
    }

    if (caid !== undefined && caid !== null) {
      headers['caid'] = String(caid);
    }

    let tokenizedReq = req.clone({
      setHeaders: headers
    })

    return next.handle(tokenizedReq);

  }
}
